// initial state
const state = {
  size: 'xs'
}

// getters
const getters = {

}

// mutations
const mutations = {
  update: (state: any, value: string) => {
    state.size = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
